import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';
import { rOyakKiraBilgileriUstBilgiKvtDetay } from '../../../../api/models/rOyakKiraBilgileriUstBilgiKvtDetay';
export default ApiBaseReducer<
  pList,
  IInputDataStateModel<pList, rOyakKiraBilgileriUstBilgiKvtDetay>,
  rOyakKiraBilgileriUstBilgiKvtDetay
>(
  ActionSubTypes.API_OYAKKIRABILGILERIUSTBILGIKVTDETAY,
  DefaultInputDataStateModel<pList, rOyakKiraBilgileriUstBilgiKvtDetay>()
);
